/**
 * FRP-owned footer copy (spec AC-1, AC-3, AC-5, AC-6). Fixed strings: do not
 * reword. The year is supplied by the caller; this module never reads the clock.
 */
export interface PortalFooterLink {
  readonly text: string;
  readonly href: string;
}

export const portalFooterContent = {
  navAccessibleName: "Legal",
  links: [
    { text: "Terms & Conditions", href: "https://foundationrp.com/terms-conditions/" },
    { text: "Privacy Policy", href: "https://foundationrp.com/privacy-policy/" },
    { text: "Accessibility", href: "https://foundationrp.com/accessibility/" },
    { text: "Contact Us", href: "https://foundationrp.com/contact/" },
  ] as readonly PortalFooterLink[],
  separator: "|",
  newTabSuffix: " (opens in new tab)",
  copyright: (year: number): string =>
    `© ${year} Foundation Risk Partners. All Rights Reserved. CA License #0M93299`,
} as const;
